const CollectionFilterCategories = (el, sectionParams, onChangeFilterParams) => {
  let filterParams = [];
  const categoryList = sectionParams.category_list;
  let otherRowChecked = false;

  const initialize = () => {
    renderCategoryItems();
    const button = el.querySelector(".fs-clear-button");
    button.addEventListener("click", () => {
      const newFilterParams = filterParams.filter((kv) => kv.key != "collections");
      otherRowChecked = false;
      onChangeFilterParams(newFilterParams);
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  };

  const setFilterParams = (newFilterParams) => {
    const currentValues = filterParams.filter((fp) => fp.key == "collections").map((fp) => fp.value);
    const newValues = newFilterParams.filter((fp) => fp.key == "collections").map((fp) => fp.value);
    let needsRender = true;
    if (0 < newValues.length) {
      needsRender = newValues.find((nv) => {
        if (currentValues.includes(nv)) {
          return false;
        }
        const category = categoryList.find((c) => c.handle == nv);
        if (!category) {
          return false;
        }
        if (category.levels == 1) {
          return true;
        }
        return false;
      });
    }
    filterParams = newFilterParams;
    if (needsRender) {
      renderCategoryItems();
    }
  };

  const renderCategoryItems = () => {
    const rowsEl = el.querySelector(".fs-item-rows");
    if (!rowsEl.classList.contains("collapse")) {
      rowsEl.classList.add("collapse");
      setTimeout(() => renderCategoryItems(), 400);
      return;
    }
    setTimeout(() => rowsEl.classList.remove("collapse"), 600);
    rowsEl.innerHTML = "";

    const selectedParents = categoryList.filter((categoryItem) =>
      filterParams.find(
        (kv) =>
          kv.key == "collections" &&
          (kv.value == categoryItem.handle || 0 <= categoryItem.items.findIndex((ci) => kv.value == ci.handle)),
      ),
    );
    if (selectedParents.length == 1) {
      addCategoryItemRow(selectedParents[0], true, true, rowsEl);
      addOtherRow(rowsEl, selectedParents[0]);
    } else {
      categoryList.forEach((categoryItem) => {
        addCategoryItemRow(categoryItem, true, false, rowsEl);
      });
    }

    el.querySelectorAll("input").forEach((input) => {
      input.addEventListener("change", (e) => {
        if (e.target.value == "other") {
          otherRowChecked = e.target.checked;
          if (otherRowChecked) {
            rowsEl.querySelector(".fs-other-rows").classList.add("open");
          } else {
            rowsEl.querySelector(".fs-other-rows").classList.remove("open");
          }
          return;
        }
        if (e.target.checked) {
          if (e.target.dataset.levels == 1) {
            const newFilterParams = filterParams.filter((kv) => kv.key != "collections");
            otherRowChecked = false;
            onChangeFilterParams([...newFilterParams, { key: e.target.name, value: e.target.value }]);
            window.scrollTo({ top: 0, behavior: "smooth" });
            return;
          }
          const selectedParent = categoryList.find(
            (categoryItem) =>
              categoryItem.levels == 1 && 0 <= categoryItem.items.findIndex((ci) => ci.handle == e.target.value),
          );
          const removeItemHandles = selectedParent.items.map((categoryItem) => categoryItem.handle);
          const newFilterParams = filterParams.filter(
            (kv) =>
              kv.key != "collections" ||
              (kv.key == "collections" && selectedParent.handle != kv.value && !removeItemHandles.includes(kv.value)),
          );
          rowsEl.querySelectorAll(`input[data-levels="1"]`).forEach((input) => {
            input.checked = false;
          });
          rowsEl.querySelectorAll(`input[data-levels="0"]`).forEach((input) => {
            if (input.value != e.target.value) {
              input.checked = false;
            }
          });
          onChangeFilterParams([...newFilterParams, { key: e.target.name, value: e.target.value }]);
          window.scrollTo({ top: 0, behavior: "smooth" });
        } else {
          if (e.target.dataset.levels == 1) {
            const newFilterParams = filterParams.filter((kv) => kv.key != "collections");
            otherRowChecked = false;
            onChangeFilterParams(newFilterParams);
            window.scrollTo({ top: 0, behavior: "smooth" });
            return;
          }
          const newFilterParams = filterParams.filter(
            (kv) => kv.key != "collections" || (kv.key == "collections" && kv.value != e.target.value),
          );
          onChangeFilterParams(newFilterParams);
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      });
    });
  };

  const addCategoryItemRow = (categoryItem, isParent, isOpen, itemRowsEl) => {
    const identifier = `fs_collections_${categoryItem.identifier}`;
    const className = isParent ? "fs-parent" : "fs-child";
    const checked = 0 <= filterParams.findIndex((kv) => kv.key == "collections" && kv.value == categoryItem.handle);
    const itemRow = `
      <div class="fs-item-row">
        <label for="${identifier}" class="${className}">
          ${categoryItem.title}
        </label>
        <div class="checkmark">
          <input
            id="${identifier}"
            type="checkbox"
            class="${className}"
            name="collections"
            value="${categoryItem.handle}"
            data-levels="${categoryItem.levels}"
            ${checked ? "checked" : ""}
          >
        </div>
      </div>
    `;
    itemRowsEl.innerHTML += itemRow;
    if (isOpen) {
      categoryItem.items?.forEach((childCategoryItem) =>
        addCategoryItemRow(childCategoryItem, false, false, itemRowsEl),
      );
    }
  };

  const addOtherRow = (itemRowsEl, selectedParent) => {
    const identifier = "fs_collections_other";
    const className = "fs-parent";
    const itemRow = `
      <div class="fs-item-row">
        <label for="${identifier}" class="${className}">
          その他のカテゴリー
        </label>
        <div class="checkmark arrow">
          <input
            id="${identifier}"
            type="checkbox"
            class="${className}"
            name="collections"
            value="other"
            data-levels="1"
            ${otherRowChecked ? "checked" : ""}
          >
        </div>
      </div>
    `;
    itemRowsEl.innerHTML += itemRow;

    const otherRows = document.createElement("div");
    otherRows.classList.add("fs-other-rows");
    if (otherRowChecked) {
      otherRows.classList.add("open");
    }
    categoryList.forEach((categoryItem) => {
      if (categoryItem.identifier != selectedParent.identifier) {
        addCategoryItemRow(categoryItem, false, false, otherRows);
      }
    });
    itemRowsEl.innerHTML += otherRows.outerHTML;
  };

  initialize();
  return {
    setFilterParams: setFilterParams,
  };
};

export default CollectionFilterCategories;
